import { Injectable } from '@angular/core';
import { CrmEndpointDecorator } from 'common-module/endpoint';
import { Observable } from 'rxjs';
import { Media } from '@app/core/model/document-media';
import { ImportDocumentType } from '@app/pages/imports/import-document-type';

import { ProductMedia } from '../model/product';

import { MediaEndpoint } from './media.endpoint';

export type CopyMediaPair = {
  sourceMaterialCode: string;
  targetMaterialCode: string;
};

export type CopyMediaPayload = {
  sourceCommercialYear: string;
  targetCommercialYear: string;
  pairs: CopyMediaPair[];
};

export type CopyMediaResult = {
  successImports: number;
  failedImports: { rowNo: number; error: string }[];
};

@Injectable({ providedIn: 'root' })
export class MediaService {
  @CrmEndpointDecorator({
    endpointName: 'media',
    configName: 'crm',
    endpoint: MediaEndpoint
  })
  endpoint!: MediaEndpoint;

  list(params?: any) {
    return this.endpoint.list({
      params
    }) as unknown as Observable<ProductMedia[]>;
  }

  get(id: string, options?: object) {
    return this.endpoint.read(id, options);
  }

  downloadMedia(id: string, options?: object) {
    return this.endpoint.request('GET', `resource/${id}/thumbnail`, options);
  }

  uploadDocument(file: any, documentMeta: any) {
    const formData = new FormData();
    Object.entries(documentMeta).forEach(([key, value]) => formData.append(key, value as any));
    formData.append('file', file);
    return this.endpoint.create<Media>(formData as any) as Observable<Media>;
  }

  updateMedia(id: string, body: any) {
    return this.endpoint.update(id, body);
  }

  uploadZipDocument(file: any, documentType: ImportDocumentType) {
    const formData = new FormData();
    formData.append('file', file);
    return this.endpoint.request('POST', 'import', {
      body: formData,
      params: {
        type: documentType
      },
      headers: {
        Accept: '*/*'
      }
    });
  }

  deleteMedia(_id: string) {
    return this.endpoint.delete(_id);
  }

  copyMedia(payload: CopyMediaPayload) {
    return this.endpoint.request<CopyMediaResult>('POST', 'copy', {
      body: payload,
    });
  }

  exportMedia(productIds: string[], tags: string[]) {
    return this.endpoint.request('POST', 'export', {
      body: { ids: productIds, tags } as any,
      responseType: 'blob'
    }) as Observable<Blob>;
  }
}
